import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-jump-to-page',
  templateUrl: './jump-to-page.component.html',
  styleUrls: ['./jump-to-page.component.scss'],
})
export class JumpToPageComponent implements OnInit {
  @Input()
  public page: number;

  @Output('pageEmitter')
  private pageEmitter: EventEmitter<number>;

  constructor() {
    this.pageEmitter = new EventEmitter<number>();
  }

  ngOnInit() {}

  public onBlur() {
    if (!this.page) {
      this.page = 1;
    }
    this.pageEmitter.emit(this.page);
  }

  public onQuantityInput(event: any): void {
    const pattern = /^[0-9]+$/;

    if (event.key.length === 1 && !pattern.test(event.key)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  public onKeyUp(event): void {
    if (event && event.key === 'Enter') {
      event.target.blur();
    }
  }
}
